import { StackCardInterpolatedStyle, StackCardInterpolationProps } from "@react-navigation/stack";

export const forSlideFromLeftAnimation = ({
    current,
    layouts,
}: StackCardInterpolationProps): StackCardInterpolatedStyle => {
    const translateX = current.progress.interpolate({
        inputRange: [0, 1],
        outputRange: [layouts.screen.width, 0],
    });
    return {
        cardStyle: {
            transform: [{ translateX }],
        },
    };
};